import React from 'react'

import { FindMyCowMessage } from '#/components/FindMyCow/Types/Message'

import { FindMyCowWrapper } from './FindMyCow'
import { FindMyCowGeneral } from './General'
import { FindMyCowHeader } from './Header'
import { FindMyCowMap } from './Map'
import { FindMyCowSubtitle } from './Subtitle'
import { FindMyCowTitle } from './Title'

export function FindMyCowElements(props) {
  const types = {
    'header': <FindMyCowHeader {...props} />,
    'title': <FindMyCowTitle {...props} />,
    'subtitle': <FindMyCowSubtitle {...props} />,
    'general': <FindMyCowGeneral {...props} />,
    'find-my-cow': <FindMyCowWrapper {...props} />,
    'map': <FindMyCowMap {...props} />,
    'message': <FindMyCowMessage {...props} />,
    'animal_location_status': <FindMyCowMessage {...props} />,
  }

  return <div key={props.id}>{types[props.id]}</div>
}
